(function () {
  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalizeImg(url) {
    if (!url) return "";
    if (url.indexOf("//") === 0) return "https:" + url;
    return url;
  }

  function fetchCollections(term) {
    var url =
      "/search/suggest.json?q=" +
      encodeURIComponent(term) +
      "&resources[type]=collection&resources[limit]=10";

    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var cols =
          (json &&
            json.resources &&
            json.resources.results &&
            json.resources.results.collections) || [];
        return Array.isArray(cols) ? cols : [];
      })
      .catch(function () { return []; });
  }

  function ensureStyles() {
    if (document.querySelector("style[data-ps-collections-style]")) return;

    var style = document.createElement("style");
    style.setAttribute("data-ps-collections-style", "1");
    style.textContent = [
      /* Headings */
      ".t4s-ps-collection-title, .t4s-ps-products-title{",
      "  width:100%;",
      "  text-align:center;",
      "  font-weight: 600;",
      "  font-size: 16px;",
      "  padding: 0;",
      "}",

      /* Full width inside flex/grid */
      ".t4s-mini-search__content .t4s-ps-collection-title,",
      ".t4s-mini-search__content .t4s-ps-products-title{",
      "  flex: 0 0 100%;",
      "  max-width: 100%;",
      "}",

      "[data-results-search] .t4s-ps-collection-title,",
      "[data-results-search] .t4s-ps-products-title{",
      "  grid-column: 1 / -1;",
      "}",

      /* Click safety */
      ".t4s-ps-collection{",
      "  position: relative;",
      "  z-index: 5;",
      "  pointer-events: auto;",
      "}",
      ".t4s-ps-collection a{",
      "  pointer-events: auto !important;",
      "}",

      /* Force square ratio on the image wrapper */
      ".t4s-ps-collection .t4s-search-fullwidth__image .t4s_ratio{",
      "  --aspect-ratioapt: 1/-1;",                 /* <-- ONLY CHANGE (was 1) */
      "}",
      /* Fallback if ratio var isn't honored */
      ".t4s-ps-collection .t4s-search-fullwidth__image .t4s_ratio:before{",
      "  content:'';",
      "  display:block;",
      "  padding-bottom:100%;",
      "}",

      /* Ensure background shows nicely */
      ".t4s-ps-collection .t4s-search-fullwidth__image a.t4s_ratio{",
      "  background-position: center;",
      "  background-size: cover;",
      "  background-repeat: no-repeat;",
      "}",

      /* Keep inner img non-blocking (optional, for a11y/lazy-load parity) */
      ".t4s-ps-collection img.t4s-ps-col-img{",
      "  position:absolute;",
      "  inset:0;",
      "  width:100%;",
      "  height:100%;",
      "  object-fit:cover;",
      "  opacity:0;",
      "  pointer-events:none;",
      "}",

      ""
    ].join("\n");

    document.head.appendChild(style);
  }

  function buildCollectionTile(c) {
    var href = (c && c.url) ? c.url : "#";
    var title = (c && c.title) ? c.title : "Collection";
    var rawImg = (c && c.featured_image && c.featured_image.url) ? c.featured_image.url : "";
    var imgUrl = normalizeImg(rawImg);

    // Gecko-style background image on the <a>, plus a hidden <img> inside.
    var bg = imgUrl
      ? "background-image:url(" + escapeHtml(imgUrl) + ");"
      : "background-color:rgba(var(--text-color-rgb),.06);";

    var innerImg = imgUrl
      ? '<img class="t4s-ps-col-img" loading="lazy" src="' + escapeHtml(imgUrl) + '" alt="' + escapeHtml(title) + '">'
      : "";

    return (
      '<div class="t4s-col-item t4s-col-auto t4s-search-fullwidth__item t4s-ps-collection">' +
        '<div class="t4s-row">' +
          '<div class="t4s-col-12 t4s-col-item">' +
            '<div class="t4s-search-fullwidth__image">' +
              '<a class="t4s-d-block t4s-pr t4s-oh t4s_ratio t4s-bg-11" href="' + escapeHtml(href) + '" style="' + bg + '">' +
                innerImg +
              '</a>' +
            '</div>' +
          '</div>' +
          '<div class="t4s-col-12 t4s-col-item">' +
            '<div class="t4s-search-fullwidth__info">' +
              '<a href="' + escapeHtml(href) + '" class="t4s-d-block t4s-widget__pr-title">' + escapeHtml(title) + '</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function removeInjected(resultsEl) {
    if (!resultsEl) return;
    var old = resultsEl.querySelectorAll(
      ".t4s-ps-collection, .t4s-ps-collection-title, .t4s-ps-products-title"
    );
    old.forEach(function (el) { el.remove(); });
  }

  function hasAnyProducts(resultsEl) {
    if (!resultsEl) return false;
    var items = resultsEl.querySelectorAll(".t4s-search-fullwidth__item:not(.t4s-ps-collection)");
    return items && items.length > 0;
  }

  function injectProductsHeading(resultsEl) {
    if (!resultsEl) return;

    var firstProduct = resultsEl.querySelector(".t4s-search-fullwidth__item:not(.t4s-ps-collection)");
    if (!firstProduct) return;

    var prev = firstProduct.previousElementSibling;
    if (prev && prev.classList && prev.classList.contains("t4s-ps-products-title")) return;

    firstProduct.insertAdjacentHTML(
      "beforebegin",
      '<div class="t4s-col-item t4s-col-12 t4s-ps-products-title">Products</div>'
    );
  }

  function injectCollections(resultsEl, collections) {
    if (!resultsEl) return;

    removeInjected(resultsEl);

    if (collections && collections.length) {
      var items = collections.slice(0, 4);
      var title =
        '<div class="t4s-col-item t4s-col-12 t4s-ps-collection-title">Collections</div>';
      resultsEl.insertAdjacentHTML("afterbegin", title + items.map(buildCollectionTile).join(""));
    }

    if (hasAnyProducts(resultsEl)) {
      injectProductsHeading(resultsEl);
    }
  }

  function getScopeRootFromInput(input) {
    return (
      input.closest("[data-predictive-search]") ||
      input.closest(".t4s-drawer") ||
      input.closest(".t4s-mini-search") ||
      document
    );
  }

  function findResultsEl(scopeRoot) {
    if (!scopeRoot) return null;

    var el = scopeRoot.querySelector("[data-results-search]");
    if (el) return el;

    el = scopeRoot.querySelector(".t4s-mini-search__content");
    if (el) return el;

    el = scopeRoot.querySelector(".t4s-search-fullwidth__content");
    if (el) return el;

    return null;
  }

  function isOnlyOurMutation(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];

      for (var a = 0; a < m.addedNodes.length; a++) {
        var n1 = m.addedNodes[a];
        if (n1.nodeType !== 1) continue;
        if (!n1.classList) return false;
        if (
          !n1.classList.contains("t4s-ps-collection") &&
          !n1.classList.contains("t4s-ps-collection-title") &&
          !n1.classList.contains("t4s-ps-products-title")
        ) return false;
      }

      for (var r = 0; r < m.removedNodes.length; r++) {
        var n2 = m.removedNodes[r];
        if (n2.nodeType !== 1) continue;
        if (!n2.classList) return false;
        if (
          !n2.classList.contains("t4s-ps-collection") &&
          !n2.classList.contains("t4s-ps-collection-title") &&
          !n2.classList.contains("t4s-ps-products-title")
        ) return false;
      }
    }
    return true;
  }

  function attachToInput(input) {
    if (!input || input.__psCollectionsAttached) return;
    input.__psCollectionsAttached = true;

    ensureStyles();

    var scopeRoot = getScopeRootFromInput(input);

    var state = {
      term: "",
      collections: [],
      timer: null,
      resultsEl: null,
      resultsObserver: null,
      scopeObserver: null,
      injecting: false
    };

    function watchResults() {
      var results = findResultsEl(scopeRoot);
      if (!results) return;

      if (results !== state.resultsEl) state.resultsEl = results;

      if (state.resultsObserver) state.resultsObserver.disconnect();

      state.resultsObserver = new MutationObserver(function (mutations) {
        if (state.injecting) return;
        if (isOnlyOurMutation(mutations)) return;
        scheduleInject();
      });

      state.resultsObserver.observe(results, { childList: true, subtree: false });
    }

    function doInject() {
      var results = findResultsEl(scopeRoot);
      state.resultsEl = results;
      if (!results) return;

      state.injecting = true;

      if (state.resultsObserver) state.resultsObserver.disconnect();

      try {
        if (!state.term || state.term.length < 2) {
          removeInjected(results);
        } else {
          injectCollections(results, state.collections || []);
        }
      } finally {
        state.injecting = false;
        watchResults();
      }
    }

    function scheduleInject() {
      if (state.injecting) return;
      setTimeout(function () {
        requestAnimationFrame(doInject);
      }, 0);
    }

    state.scopeObserver = new MutationObserver(function () {
      var now = findResultsEl(scopeRoot);
      if (now && now !== state.resultsEl) {
        watchResults();
        scheduleInject();
      }
    });
    if (scopeRoot !== document) {
      state.scopeObserver.observe(scopeRoot, { childList: true, subtree: true });
    }

    watchResults();
    scheduleInject();

    input.addEventListener("input", function () {
      var term = (input.value || "").trim();
      state.term = term;

      if (state.timer) clearTimeout(state.timer);

      if (term.length < 2) {
        state.collections = [];
        scheduleInject();
        return;
      }

      state.timer = setTimeout(function () {
        var now = (input.value || "").trim();
        if (now !== term) return;

        fetchCollections(term).then(function (collections) {
          var latest = (input.value || "").trim();
          if (latest !== term) return;

          state.collections = collections || [];
          scheduleInject();
        });
      }, 250);
    });
  }

  function init() {
    var inputs = document.querySelectorAll("[data-input-search]");
    for (var i = 0; i < inputs.length; i++) attachToInput(inputs[i]);

    var mo = new MutationObserver(function () {
      var inputsNow = document.querySelectorAll("[data-input-search]");
      for (var j = 0; j < inputsNow.length; j++) attachToInput(inputsNow[j]);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
